// extracted by mini-css-extract-plugin
module.exports = {"deleted":"SearchStories_deleted_e3kFF","holder":"SearchStories_holder_-wiT_"};